import { useCallback, useReducer } from 'react'
import { useSessionStorage } from 'react-use'

const reducer = (state, action) => {
  // return updated state based on `action.type`
  let newState = {...state};
  newState[action.type] = action.value;
  return newState;
}

export const useSessionStorageReducer = (SESSION_STORAGE_KEY, INITIAL_STATE) => {
  const [savedState, saveState] = useSessionStorage(
    SESSION_STORAGE_KEY,
    INITIAL_STATE,
  )

  // wrap `reducer` with a memoized function that
  // syncs the `newState` to `localStorage` before
  // returning `newState`. memoizing is important!
  const reducerSessionStorage = useCallback(
    (state, action) => {
      const newState = reducer(state, action)

      saveState(newState)

      return newState
    },
    [saveState],
  )

  // use wrapped reducer and the saved value from
  // `localStorage` as params to `useReducer`.
  // this will return `[state, dispatch]`
  return useReducer(reducerSessionStorage, savedState)
}
